import React from 'react';

const ICON_ID = 'icon-chevron';

const IconChevron = function(props) {
  return (
    <svg viewBox="0 0 14 8" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Chevron Icon</title>
      <path d="M1.456 8l5.09-5.091L11.636 8h.002l1.453-1.454L7.273.728 6.546 0 0 6.546 1.454 8z" fillRule="evenodd"/>
    </svg>
  )
}

export default IconChevron;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-chevron.jsx